

export const PageTitle = ({title}) => {

  return (
  
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '2vh', // Adjust height as needed (20% of viewport)
           
          }}>
            <label style={{ 
              fontWeight: '700', 
              fontStyle: 'oblique', 
              fontSize:'20px',
              marginBottom: '10px',
              textAlign: 'center' 
            }}>
              {title}
          </label>
      </div>
    )
  }
